import script from "./privacy-page.vue?vue&type=script&setup=true&lang=js"
export * from "./privacy-page.vue?vue&type=script&setup=true&lang=js"

import "./privacy-page.vue?vue&type=style&index=0&id=5bd02354&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd02354"]])

export default __exports__